import { useMsal } from "@azure/msal-react";
import { BaseApiService } from "./baseApiService";

export const useFirmDomainService = () => {
    const { instance } = useMsal();
    return new FirmDomainService(instance);
};

class FirmDomainService extends BaseApiService {

    async getEmailDomains(id) {
        const url = 'FirmDomain/GetEmailDomains?';
        return await this.get(url);
    }
}